import { api } from "lib/graphql/api"
import { query } from "lib/graphql/query"
import { mutate } from "lib/graphql/mutate"
import { gql } from "@apollo/client"

export const getIsUnlocked = api(async function getIsUnlocked(regimeId) {
    return (
        regimeId &&
        query(
            gql`
                query GetIsUnlocked($regimeId: String!) {
                    getIsUnlocked(regimeId: $regimeId)
                }
            `,
            { regimeId },
            { returns: "getIsUnlocked" }
        )
    )
})

export const setIsUnlocked = api(async function setIsUnlocked(regimeId, unlocked) {
    return mutate(
        gql`
            mutation SetIsUnlocked($regimeId: String!, $unlocked: Boolean!) {
                setIsUnlocked(regimeId: $regimeId, unlocked: $unlocked)
            }
        `,
        { regimeId, unlocked },
        { returns: "setIsUnlocked" }
    )
})
